var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClientsDisableIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 24,
    viewBox: "0 0 27 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6764 21.5984C19.6764 19.4776 16.9111 17.7584 13.5 17.7584C10.0888 17.7584 7.3235 19.4776 7.3235 21.5984M24.6176 17.759C24.6176 16.1843 23.0931 14.831 20.9117 14.2384M2.38232 17.759C2.38232 16.1843 3.9068 14.831 6.08821 14.2384M20.9117 9.10065C21.6698 8.39753 22.147 7.37572 22.147 6.23844C22.147 4.11767 20.4879 2.39844 18.4411 2.39844C17.4919 2.39844 16.6263 2.76817 15.9706 3.37622M6.08821 9.10065C5.33004 8.39753 4.85291 7.37572 4.85291 6.23844C4.85291 4.11767 6.5121 2.39844 8.55879 2.39844C9.50793 2.39844 10.3737 2.76817 11.0294 3.37622M13.5 13.9184C11.4532 13.9184 9.79409 12.1993 9.79409 10.0784C9.79409 7.95767 11.4532 6.23844 13.5 6.23844C15.5467 6.23844 17.2059 7.95767 17.2059 10.0784C17.2059 12.1993 15.5467 13.9184 13.5 13.9184Z",
    stroke: "#444444",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClientsDisableIcon);
export default __webpack_public_path__ + "static/media/ClientsDisableIcon.9e2090b6f88d48cea5916889c31a2cbb.svg";
export { ForwardRef as ReactComponent };